<div class="wrapper">
    <div #contentRef class="upp-scrollable-content"
        [ngClass]="{
            'mobile': view.Mobile,
            'show': view.Scrollbar,
            '--mouse-draggable': IsMouseDraggable,
            '--mouse-dragging': IsMouseDragging
        }"
        (scroll)="OnContentScroll($event)"
        (pointerdown)="OnPointerDown($event)"
        (dragstart)="OnDragStart($event)"
    >
        <div class="scroll-slot" [ngClass]="{ '--x-axis': scrollbar === 'x' }">
            <div class="top-gap" aria-hidden="true"></div>
            <ng-content></ng-content>
            <div class="bottom-gap" aria-hidden="true"></div>
        </div>
    </div>
</div>
